'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = analyticsMiddleware;

var _reactRouterRedux = require('react-router-redux');

var _track = require('./track');

var _track2 = _interopRequireDefault(_track);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function analyticsMiddleware() {
  return function (next) {
    return function (action) {
      if (action.type === _reactRouterRedux.LOCATION_CHANGE) {
        (0, _track2.default)(action.payload.pathname);
      }
      return next(action);
    };
  };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/redux/middlewares/analytics/index.js
// module id = 1296
// module chunks = 0